var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VmToggle',{attrs:{"label":_vm.text,"on-label":_vm.$t('profile.pleaseRemind'),"off-label":_vm.$t('profile.dontRemind')},model:{value:(_vm.inputtedRemind),callback:function ($$v) {_vm.inputtedRemind=$$v},expression:"inputtedRemind"}})}
var staticRenderFns = []

export { render, staticRenderFns }